// src/components/alert/FactorWarning.tsx

import { Alert, Typography } from '@mui/material'

import { MeterNumber, SensorId, SensorName } from '@/types/domain'

import { userLocales } from '../../api'
import {
  OperatorData,
  useMeterNumber,
  useOperator,
  useSensorName,
} from '../../hooks'

const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' }

type FactorWarningProps = {
  id: SensorId
  date: Date
  factors: any[]
}

export const FactorWarning = ({ id, date, factors }: FactorWarningProps) => {
  const meter: MeterNumber = useMeterNumber(id)
  const name: SensorName = useSensorName(id)
  const opData: OperatorData = useOperator()

  const dateFormated: string = date.toLocaleString(userLocales, options)

  const FILTER_SENSORID = f => f[0]?.sensor_id === id

  const ffactors = factors.filter(FILTER_SENSORID)

  const firstRecord: string = new Date(
    ffactors?.[0]?.period_start
  ).toLocaleDateString(userLocales)

  return (
    <Alert severity={'warning'} sx={{ mb: 1, mx: 5 }}>
      <Typography sx={{ mb: 2 }}>
        Monatsberichte können nur für vollständige Monate generiert werden. Bei
        folgendem Messpunkt liegen für {dateFormated} keine vollständigen Daten
        vor:
      </Typography>

      <Typography sx={{ mb: 2 }}>
        Name: <strong>{name}</strong> | Zählernummer:
        <strong>{meter}</strong> |{opData?.isAdmin && ` SensorID: ${id} | `}
        Daten seit: <strong>{firstRecord}</strong>
      </Typography>

      <Typography>
        Der Messpunkt wird bei der Erstellung des Monatsberichts nicht
        berücksichtigt.
      </Typography>
    </Alert>
  )
}
